import { useQuery } from '@tanstack/react-query';
import { IBussinessAccountDetailResponse } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';

export const getBusinessAccountDetails = async (id: string) => {
  const res = await apiManager.get<IBussinessAccountDetailResponse>(
    `/admin/business-account/${id}`
  );
  return res;
};

export const useGetBusinessAccountDetails = (id: string) =>
  useQuery({
    queryKey: ["get_business_account_details", id],
    queryFn: async (): Promise<IBussinessAccountDetailResponse> => {
      const res = await apiClient.get(`/admin/business-account/${id}`);
      return res.data;
    },
    enabled: !!id,
  });